import { render, staticRenderFns } from "./NumberGrow.vue?vue&type=template&id=5658e56a&"
import script from "./NumberGrow.vue?vue&type=script&lang=js&"
export * from "./NumberGrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports